import { useSendValidation } from "../useSendValidationFiado";
import { useCancelDigitalSign } from "./useCancelDigitalSign";

export default function useSignatureComparison() {
  const { cancelDigitalSign } = useCancelDigitalSign();
  const sendValidationFiado = useSendValidation();
  
  const sendToFAD = async (idProceso: string) => {
    console.log("Enviando a FAD el proceso: ", idProceso);
    try {
      const response = await sendValidationFiado({ idProceso });
      if (response !== "OK") {
        throw new Error("Error al enviar la invitación");
      }
    } catch (error) {
      throw error;
    }
  };
  const changeToManualSign = async (idProcess: string) => {
    console.log("Cambiando a firma manual el proceso: ", idProcess);
    try {
      const response = await cancelDigitalSign({ idProcess: idProcess });
      if (response !== "OK") {
        throw new Error("Error al enviar la invitación");
      }
    } catch (error) {
      throw error;
    }
  };
  return { sendToFAD, changeToManualSign };
}